// This file imports the needed routes and makes them available in the global window object.
// aka inline javascript
// 
// This is an ongoing refactoring. The inline JS should be removed.

// !!!! DO NOT ADD NEW ONES !!!!
import {
  download_project_file_path,
  programme_management_color_schemes_path
} from '../../routes';

// Exposing the routes to the global window object
window.Routes = {
  download_project_file_path,
  programme_management_color_schemes_path
};
